import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import {
  GET_EVENT_SUBSCRIPTION_CHECKOUT_CART,
  type EventSubscriptionCheckoutCartResponse,
} from '@/state/queries/transactions/use-event-subscription-checkout-cart';

export type PatchEventSubscriptionCheckoutCartDto = {
  clear?: boolean;
  lines?: Array<{
    subscriptionProductKey: string;
    tier?: string;
    billingPeriod?: string;
    additionalQuotaUnits?: { quotaKey: string; quantity: number }[];
    parentSubscriptionInstanceId?: string;
    scopeType?: string;
    scopeId?: string;
  }>;
};

export function usePatchEventSubscriptionCheckoutCart(eventId: string | undefined) {
  const { getToken } = useAuth();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (dto: PatchEventSubscriptionCheckoutCartDto): Promise<EventSubscriptionCheckoutCartResponse> => {
      if (!eventId) throw new Error('eventId required');
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/transactions/event/${eventId}/subscription-checkout-cart`;
      return sendJSONRequest({
        url,
        method: METHOD.PATCH,
        token: token ?? '',
        body: dto,
      });
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: [GET_EVENT_SUBSCRIPTION_CHECKOUT_CART, eventId] });
    },
  });
}
